import { Graph, Thing } from "schema-dts"

export type LinkedDataProps = {
  data: Thing | Thing[]
}

export const LinkedData = ({ data }: LinkedDataProps) => {
  const graph: Graph = {
    "@context": "https://schema.org",
    "@graph": [data].flat(),
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(graph),
      }}
    />
  )
}
